import dateComparator from "./DateComparator";
import filterParams from "./DateFilter";

export const columnDefs = [
  {
    headerName: "Numero",
    valueGetter: "node.rowIndex + 1",
    width: 90,
    suppressSizeToFit: false,
    checkboxSelection: true,
    minWidth: 90,
    maxWidth: 90,
    // cellClass: (params) => {
    //   let ID = sessionStorage.getItem("ID_Session");
    //   if (params.data.fk_id_patient1 == ID) {
    //     return "aggridGoBackStyles";
    //   } else {
    //     return "null"
    //   }
    // },
  },
  {
    headerName: "ID",
    field: "fk_id_patient1",
    hide: true,
  },
  {
    headerName: "id_Magica",
    field: "id_Magica",
    hide: true,
  },
  {
    headerName: "date_consultation_For_Server",
    field: "date_consultation_For_Server",
    hide: true,
  },
  {
    headerName: "done",
    field: "done",
    hide: true,
  },
  {
    headerName: "didnt_come",
    field: "didnt_come",
    hide: true,
  },
  {
    headerName: "ID_Act",
    field: "fk_id_acte",
    hide: true,
  },
  {
    headerName: "date consultation",
    field: "date_consultation",
    filter: "agDateColumnFilter",
    filterParams: filterParams,
    sortable: true,
    comparator: dateComparator,
    hide: true,
  },
  {
    headerName: "Nom",
    field: "nom",
    filterParams: {
      defaultOption: "startsWith",
    },
    cellStyle: { textAlign: "center" },
    cellClass: (params) => {
      let ID = sessionStorage.getItem("ID_Session");
      // eslint-disable-next-line
      if (params.data.fk_id_patient1 == ID) {
        return "aggridGoBackStyles";
      } else {
        return "null";
      }
    },
    floatingFilter: true,
  },
  {
    headerName: "Prenom",
    field: "prenom",
    filterParams: {
      defaultOption: "startsWith",
    },
    cellStyle: { textAlign: "center" },
    cellClass: (params) => {
      let ID = sessionStorage.getItem("ID_Session");
      // eslint-disable-next-line
      if (params.data.fk_id_patient1 == ID) {
        return "aggridGoBackStyles";
      } else {
        return "null";
      }
    },
    floatingFilter: true,
  },
  {
    headerName: "Age",
    field: "age",
    filterParams: {
      defaultOption: "startsWith",
    },
    cellStyle: { textAlign: "center" },
    cellClass: (params) => {
      let ID = sessionStorage.getItem("ID_Session");
      // eslint-disable-next-line
      if (params.data.fk_id_patient1 == ID) {
        return "aggridGoBackStyles";
      } else {
        return "null";
      }
    },
  },
  {
    headerName: "Prestation",
    field: "nom_acte",
    filterParams: {
      defaultOption: "contains",
    },
    cellStyle: { textAlign: "center" },
    cellClass: (params) => {
      let ID = sessionStorage.getItem("ID_Session");
      // eslint-disable-next-line
      if (params.data.fk_id_patient1 == ID) {
        return "aggridGoBackStyles";
      } else {
        return "null";
      }
    },
    floatingFilter: true,
  },
  {
    headerName: "Montant total",
    field: "sum_act",
    filterParams: {
      defaultOption: "startsWith",
    },
    cellStyle: { textAlign: "center" },
    cellClass: (params) => {
      let ID = sessionStorage.getItem("ID_Session");
      // eslint-disable-next-line
      if (params.data.fk_id_patient1 == ID) {
        return "aggridGoBackStyles";
      } else {
        return "null";
      }
    },
    hide: true,
  },
  {
    headerName: "Reste a payer",
    field: "rest",
    filterParams: {
      defaultOption: "startsWith",
    },
    cellClass: (params) => {
      // params.value === 0
      //   ? "paid"
      //   : params.value > 0
      //   ? "unpaid"
      //   : params.value < 0
      //   ? "overPaid"
      //   : null,
      // eslint-disable-next-line
      if (params.value == 0) {
        return "paid";
      } else if (params.value > 0) {
        return "unpaid";
      } else if (params.value < 0) {
        return "overPaid";
      } else {
        return "null";
      }
    },
  },
  {
    headerName: "Terminé à ",
    field: "moved_at",

    filter: "agDateColumnFilter",
    filterParams: filterParams,
    sortable: true,
    comparator: dateComparator,
    cellStyle: { textAlign: "center" },
    cellClass: (params) => {
      let ID = sessionStorage.getItem("ID_Session");
      // eslint-disable-next-line
      if (params.data.fk_id_patient1 == ID) {
        return "aggridGoBackStyles";
      } else {
        return "null";
      }
    },
    hide: true,
  },
  {
    headerName: "Date de creation",
    field: "created_at",

    filter: "agDateColumnFilter",
    filterParams: filterParams,
    sortable: true,
    comparator: dateComparator,
    cellStyle: { textAlign: "center" },
    cellClass: (params) => {
      let ID = sessionStorage.getItem("ID_Session");
      // eslint-disable-next-line
      if (params.data.fk_id_patient1 == ID) {
        return "aggridGoBackStyles";
      } else {
        return "null";
      }
    },
    hide: true,
  },
  {
    headerName: "couleur",
    field: "couleur",
    filterParams: {
      defaultOption: "startsWith",
    },
    hide: true,
  },

  {
    headerName: "Date de naissance",
    field: "date_naissance",
    filter: "agDateColumnFilter",
    filterParams: filterParams,
    sortable: true,
    comparator: dateComparator,
    hide: true,
  },
];
export const columnDefs2 = [
  {
    headerName: "date_consultation_For_Server",
    field: "date_consultation_For_Server",
    hide: true,
  },
  {
    headerName: "Total du :",
    field: "total",
    cellStyle: { textAlign: "center" },
  },
  {
    headerName: "date consultation",
    field: "date_consultation",
  },
  {
    headerName: "gain latent",
    field: "gain_latent",
    cellStyle: { textAlign: "center" },
  },
  {
    headerName: "montant total",
    field: "sum_act",
    cellClass: (params) => (params.value > 0 ? "gain_latent" : null),
  },
  {
    headerName: "Payment_titre",
    field: "payment_titre",
    cellStyle: { textAlign: "center" },
  },
  {
    headerName: "payment",
    field: "payment",
    cellClass: (params) =>
      params.value === 0
        ? "unpaidFooter"
        : params.value > 0
          ? "paidFooter"
          : null,
  },
  {
    headerName: "reste_a_payer_titre",
    field: "reste_a_payer_titre",
    cellStyle: { textAlign: "center" },
  },
  {
    headerName: "reste a payer",
    field: "rest",
    cellStyle: { textAlign: "center" },
    // cellClass: (params) =>
    //   params.value === 0
    //     ? "paidFooter"
    //     : params.value > 0
    //     ? "unpaidFooter"
    //     : params.value < 0
    //     ? "overPaidFooter"
    //     : null,
  },
  // {
  //   headerName: "Numero",
  //   valueGetter: "node.rowIndex + 1",
  //   width: 90,
  //   suppressSizeToFit: false,
  //   checkboxSelection: true,
  //   minWidth: 90,
  //   maxWidth: 90,
  // },
];

// export const defaultColDef = {
//   sortable: true,
//   flex: 1,
//   // filter stuff
//   filter: true,
//   floatingFilter: true,
//   suppressMenu: true,
//   // end of filter stuff
//   minWidth: 100,
//   resizable: true,
//   filterParams: {
//     newRowsAction: "keep",
//   },
// };

export const topOptions = {

  alignedGrids: [],
  defaultColDef: {
    suppressMovable: true,
    sortable: true,
    flex: 1,
    // filter stuff
    filter: true,

    suppressMenu: true,
    // end of filter stuff
    minWidth: 100,
    resizable: true,
    filterParams: {
      newRowsAction: "keep",
    },
  },
  suppressHorizontalScroll: true,
};

export const bottomOptions = {

  alignedGrids: [],
  defaultColDef: {
    sortable: true,
    flex: 1,
    // filter stuff
    filter: true,
    // floatingFilter: true,
    suppressMenu: true,
    // end of filter stuff
    minWidth: 100,
    resizable: true,
    filterParams: {
      newRowsAction: "keep",
    },
  },
};
